import React, { useState, useEffect } from 'react';
import * as S from './AnimatedProgressBarStyle';

const AnimatedProgressBar = ({ title, value, total, currency = false }) => {
    const [animatedValue, setAnimatedValue] = useState(0);

    const percentage = total > 0 ? (value / total) * 100 : 0;

    useEffect(() => {
        const duration = 1500;
        const frameRate = 1000 / 60;
        const totalFrames = Math.round(duration / frameRate);
        let currentFrame = 0;

        const counter = setInterval(() => {
            currentFrame++;
            const progress = currentFrame / totalFrames;
            const currentValue = value * progress;
            setAnimatedValue(currentValue);

            if (currentFrame === totalFrames) {
                clearInterval(counter);
                setAnimatedValue(value);
            }
        }, frameRate);

        return () => clearInterval(counter);
    }, [value]);

    const formatNumber = (num) => {
        return num.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    return (
        <S.ProgressBarContainer>
            <S.Header>
                <S.Title>{title}</S.Title>
                <S.PercentageText>
                    {percentage.toFixed(2)}%
                </S.PercentageText>
            </S.Header>
            <S.BarTrack>
                <S.BarFill percentage={percentage} />
            </S.BarTrack>
            <S.InfoFooter>
                <span>
                    {currency ? `R$ ${formatNumber(animatedValue)}` : formatNumber(animatedValue)}
                </span>
                <span>
                    {currency ? `R$ ${formatNumber(total)}` : formatNumber(total)}
                </span>
            </S.InfoFooter>
        </S.ProgressBarContainer>
    );
};

export default AnimatedProgressBar; // <-- A LINHA QUE FALTAVA